<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-action corner">
      <div class="button button-close">
        <button class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </button>
      </div>
    </div>
    <div class="popup-container">
      <div class="popup">
        <div class="popup-title">
          <span v-if="group1.isSearchDetail" class="popup-title-main">検索結果</span>
          <span v-else class="popup-title-main">絞り込みの設定</span>
        </div>
        <div class="popup-content">
          <div class="list01">

            <SPPackageAndProductsTreeItem
              :model="group1.packagesAndProductsAreaTreeData"
              :isSearchCountShown="group1.isSearchCountShown"
              :isSearchDetail="group1.isSearchDetail"
              @emitItemClicked="group1.onPackageAndProductsTreeItemClicked"
            />

            <nav v-if="group1.packagesAndProductsAreaBooks.length > 0" class="list01 bg-02">
              <ul>
                <li v-for="(item, index) in group1.packagesAndProductsAreaBooks" :key="'single_books_' + index" class="list01-item is-parent is-open">
                  <div class="label">
                    <div class="formparts checkbox">
                      <input type="checkbox" 
                        v-model="group1.single_books" :value="item.product_id + ',' + item.book_id"
                        @change="group1.onSingleBookClicked"
                        :id="'package_product_books_' + item.id"
                      >
                      <label :for="'package_product_books_' + item.id"
                        >{{ item.name }} <template v-if="group1.isSearchCountShown">({{ item.search_count }})</template><FontawesomeIcon icon="check" class="icn" /></label>
                    </div>
                  </div>
                </li>
              </ul>
            </nav>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'

import SPPackageAndProductsTreeItem from '@/components/sp/partial/qa/SPPackageAndProductsTreeItem'

export default defineComponent({
  components: {
    SPPackageAndProductsTreeItem
  },
  props: {
    parentGroup1: {
      type: Object,
      required: true
    }
  },
  setup (props, context) {

    const group1 = props.parentGroup1

    const close = () => {
      context.emit('closeSearchExtract')
    }

    const submit = () => {
      group1.search()
      context.emit('closeSearchExtract')
    }

    return {
      group1,
      close,
      submit
    }
  }
})
</script>

<style lang="scss" scoped>
</style>
